export function esFlagActivo(valor) {
    return valor === true || valor === "1" || Number(valor) === 1;
}

export function textoOGuion(valor) {
    if (valor == null) return "—";
    const t = String(valor).trim();
    return t || "—";
}

function nuevaIdFilaUnidad() {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
        return crypto.randomUUID();
    }
    return `unidad-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function nuevaUnidadNegocioIdFila() {
    return nuevaIdFilaUnidad();
}

/**
 * @param {unknown} raw
 * @returns {Array<Record<string, unknown>>}
 */
export function normalizarUnidadesNegocio(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((item) => item && typeof item === "object")
        .map((item, idx) => {
            const idFila =
                typeof item.idFila === "string" && item.idFila.trim()
                    ? item.idFila.trim()
                    : item.id != null
                      ? `db-${item.id}`
                      : `unidad-${idx}-${item.razon_social ?? ""}-${item.direccion ?? ""}`;
            return { ...item, idFila };
        });
}

/**
 * @param {unknown} filas
 * @returns {Array<{ razon_social: string, direccion: string, id_pais: number|null, id_provincia: number|null, id_localidad: number|null }>}
 */
export function serializeUnidadesNegocioParaApi(filas) {
    if (!Array.isArray(filas)) return [];
    return filas
        .map((f) => {
            if (!f || typeof f !== "object") return null;
            const razon_social = String(f.razon_social ?? "").trim();
            const direccion = String(f.direccion ?? "").trim();
            const id_pais =
                f.id_pais != null && f.id_pais !== "" ? Number(f.id_pais) : null;
            const id_provincia =
                f.id_provincia != null && f.id_provincia !== "" ? Number(f.id_provincia) : null;
            const id_localidad =
                f.id_localidad != null && f.id_localidad !== "" ? Number(f.id_localidad) : null;
            if (!razon_social || !direccion || !Number.isFinite(id_pais)) return null;
            const row = {
                razon_social,
                direccion,
                id_pais,
                id_provincia: Number.isFinite(id_provincia) ? id_provincia : null,
                id_localidad: Number.isFinite(id_localidad) ? id_localidad : null,
            };
            if (f.id != null && Number.isFinite(Number(f.id))) {
                row.id = Number(f.id);
            }
            return row;
        })
        .filter(Boolean);
}

export function esPaisArgentina(idPais, paises = []) {
    const p = (paises || []).find((x) => Number(x.id_pais) === Number(idPais));
    const nombre = String(p?.pais ?? "").toLowerCase();
    return nombre.includes("argentina");
}

/**
 * Ids de empresa a la que factura: `empresasSeleccionadas` o `empresas[].id_empresa`.
 * @param {{ empresasSeleccionadas?: unknown, empresas?: unknown } | null | undefined} row
 * @returns {number[]}
 */
export function idsEmpresasDesdeProveedor(row) {
    if (!row || typeof row !== "object") return [];
    if (Array.isArray(row.empresasSeleccionadas)) {
        return row.empresasSeleccionadas.map(Number).filter((id) => Number.isFinite(id));
    }
    if (Array.isArray(row.empresas)) {
        return row.empresas
            .map((item) => Number(item?.id_empresa))
            .filter((id) => Number.isFinite(id));
    }
    return [];
}

export function tieneEmpresaSeleccionada(ids, idEmpresa) {
    const id = Number(idEmpresa);
    if (!Number.isFinite(id) || !Array.isArray(ids)) return false;
    return ids.some((item) => Number(item) === id);
}
